import React, { Component, Fragment } from 'react';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import Image from '../../../config/images/gambar';
import { Link } from 'react-router-dom';
import { Capitalize } from '../../../config/utils';
import DateIndo from '../../../config/dateIndo';
import { getListPengajuan, getUser } from '../../../services/api-services/krs-api';
import { getSemester } from '../../../services/api-services/filterdropdown';

var nowDate = new Date();
var tanggal = DateIndo(nowDate)

class Krs extends Component {

    state = {
        ttd: "",
        user: {
            angkatan: '',
            jurusan: '',
            kdjur: '',
            kurikulum: '',
            nama: '',
            nim: '',
            semester: '',
            smtta: '',
            ta: '',
            nidn: '',
            dosenwali: ''
        },
        OptSemester: [],
        listPengajuan: {
            data: [],
            sks_semesterini: 0,
            sks_semuasemester: 0,
            sksteori_semesterini: 0,
            skspraktek_semesterini: 0,
            sksteori_semuasemester: 0,
            skspraktek_semuasemester: 0
        },
        isLoading: false,
        selectedSemester: '-'
    }

    getAllData = async () => {
        const { nim } = this.props.location.state
        const allPromise = Promise.all([
            getUser(nim),
            getSemester(nim)
        ])
        const promises = await allPromise
        this.setState({
            user: promises[0].data,
            listSemester: promises[1].data,
            ttd: promises[0].data.dosenwali
        })
    }

    // handle to print 
    print = () => {
        this.setState({
            ttd: this.state.user.dosenwali
        }, () => {
            const doc = new jsPDF();

            var imageAsia = Image.data

            doc.addImage(imageAsia, 'JPEG', 95, 6, 19, 19)

            var width = doc.internal.pageSize.getWidth()
            doc.setFont("Times-bold", "bold")
            doc.setFontSize(11.5);
            doc.text('INSTITUT TEKNOLOGI DAN BISNIS ASIA MALANG', width / 2, 31, { align: 'center' });

            doc.setFont("Times-bold", "bold");
            doc.setFontSize(11.5);
            doc.text("FAKULTAS TEKNOLOGI DAN DESAIN", width / 2, 36.5, { align: 'center' });

            doc.setFont("Times-Roman", "normal");
            doc.setFontSize(11.5);
            doc.text('Jl. Soekarno-Hatta, Rembuksari 1A Malang Telp.(0341) 478877 Fax.(0341) 4345225', width / 2, 41.5, { align: 'center' });

            doc.setLineWidth(0.1)
            doc.line(10, 47, 200, 47)

            doc.setFont("Times-bold", "bold");
            doc.setFontSize(11.5);

            doc.text("KARTU RENCANA STUDI", width / 2, 56, { align: 'center' });

            doc.autoTable({
                html: '#headerTabel',
                startY: doc.lastAutoTable + 63,
                theme: 'plain',
                styles: {
                    font: 'times',
                    lineColor: 'black',
                    textColor: 'black',
                    fontSize: '10.5',
                    cellPadding: 0.5
                },
                margin: { left: 10, right: 10 }
            });

            doc.autoTable({
                html: '#tabelKRS',
                theme: 'grid',
                styles: {
                    font: 'times',
                    lineColor: 'black',
                    textColor: 'black',
                    valign: 'middle',
                },
                headStyles: {
                    fillColor: [255, 255, 255],
                    lineColor: 'black',
                    valign: 'middle',
                    halign: 'center',
                    lineWidth: 0.1
                },
                columnStyles: {
                    0: { cellWidth: 10, halign: 'center' },
                    1: { cellWidth: 40, halign: 'center' },
                    3: { cellWidth: 25, halign: 'center' },
                    4: { cellWidth: 25, halign: 'center' },
                    5: { cellWidth: 25, halign: 'center' },
                },
                margin: { top: 10, left: 10, right: 10, bottom: 10 },
                didParseCell: function (data) {
                    var rows = data.table.body;
                    if (data.row.index === rows.length - 2) {
                        data.cell.styles.fontStyle = 'bold'
                    }
                    if (data.row.index === rows.length - 1) {
                        data.cell.styles.fontStyle = 'bold'
                    }
                }
            });

            doc.autoTable({
                html: '#ttd',
                theme: 'plain',
                styles: {
                    font: 'times',
                    lineColor: 'black',
                    textColor: 'black',
                    fontSize: '10.5',
                    cellPadding: 0.1,
                    halign: 'center',
                },
                margin: { top: 20, left: 110, bottom: 20 },
                didParseCell: function (data) {
                    var rows = data.table.body;
                    if (data.row.index === rows.length - 2) {
                        data.cell.styles.cellPadding = -4
                    }
                    if (data.row.index === rows.length - 1) {
                        data.cell.styles.cellPadding = 1
                    }
                    if (data.row.index === rows.length - 9) {
                        data.cell.styles.cellPadding = 1
                    }
                }
            });

            window.open(doc.output('bloburl'), '_blank')
        })
    }

    getAllData = async () => {
        const nim = localStorage.getItem('nim');

        const allPromise = Promise.all([
            getUser(nim),
            getSemester(nim)
        ])

        const promises = await allPromise

        this.setState({
            user: promises[0].data,
            OptSemester: promises[1].data
        })
    }

    getHistoryPengajuan = async (e) => {
        const nim = localStorage.getItem('nim');
        this.setState({ isLoading: true })

        const response = await getListPengajuan(nim, e.target.value)
        this.setState({
            listPengajuan: response.data,
            selectedSemester: e.target.value,
            isLoading: false
        })
    }

    componentDidMount = () => {
        this.getAllData();
    };

    render() {
        // underline for report 
        var i2;
        let output2 = "";
        for (i2 = 0; i2 < this.state.ttd.length; i2++) {
            output2 += "_";
        }
        // end underline for report 

        const { OptSemester, isLoading, selectedSemester } = this.state
        const { angkatan, jurusan, nama, nim, semester, ta, nidn, dosenwali } = this.state.user
        const { data, sks_semesterini, sks_semuasemester, sksteori_semesterini, skspraktek_semesterini, skspraktek_semuasemester, sksteori_semuasemester } = this.state.listPengajuan

        const statusTheme = (val) => {
            if (val === 'Disetujui') return 'success'
            else if (val === 'Ditolak') return 'danger'
            else if (val === 'Aktif') return 'info'
            else if (val === 'Konversi') return 'warning'
            else return 'primary'
        }

        const tableAddOns = (val) => {
            return (
                <tr>
                    <td className='text-center' colSpan={9}>
                        {
                            val === 'loading' ?
                                <div id="spinner" className="loader-1 colorful mt-5 mb-5">
                                    <div className="dot" />
                                    <div className="dot" />
                                    <div className="dot" />
                                </div>
                                : '-- Tidak Ada Data --'
                        }
                    </td>
                </tr>
            )
        }

        return (
            <Fragment>
                <div className="smooth mb-2">
                    <div className="col-md-12 mb-3">
                        <div className="row">
                            <div className="col-12 col-xl-8 mb-xl-0">
                                <p className="abu" style={{ fontSize: "15px", fontWeight: "bold", color: "#999999", textTransform: "capitalize" }}>
                                    Akademik&nbsp;&nbsp;&rsaquo;&nbsp;&nbsp;Kartu Rencana Studi
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="card card-custom">
                        <div className="card-body">
                            <p className="card-title text-center" style={{ fontSize: "25px", marginTop: "10px", marginBottom: "35px" }}>
                                Kartu Rencana Studi
                            </p>
                            <div className="table-responsive pl-2 pr-2">
                                <table className="display expandable-table tableBord table-striped" style={{ width: "100%" }}>
                                    <thead></thead>
                                    <tbody>
                                        <tr>
                                            <td>NIM</td>
                                            <td> : </td>
                                            <td>{nim}</td>

                                            <td>Angkatan</td>
                                            <td> : </td>
                                            <td>{angkatan}</td>
                                        </tr>
                                        <tr>
                                            <td>Nama</td>
                                            <td> : </td>
                                            <td>{nama}</td>

                                            <td>Semester</td>
                                            <td> : </td>
                                            <td>
                                                <select onChange={this.getHistoryPengajuan} className="form-control custom-width">
                                                    <option value="" hidden>- Pilih Semester -</option>
                                                    {
                                                        OptSemester.map((v, index) => {
                                                            return (
                                                                <option key={index} value={v.semester}>{'Semester ' + v.semester}</option>
                                                            )
                                                        })
                                                    }
                                                </select>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <br />
                            <br />
                            {/* <Link
                                to={{ pathname: "/krs/pengajuan", state: this.state.user }}
                                className="btn btn-add"
                                style={{ marginBottom: '25px' }}
                            >
                                <i className="ti-marker-alt"></i>&nbsp;&nbsp;Pengajuan KRS
                            </Link> */}
                            <p className="card-title" style={{ fontSize: "17px", marginLeft: "10px" }}>
                                Kartu rencana studi mahasiswa :
                            </p>
                            <div className="table-responsive">
                                <table width="100%" align="center" className="display expandable-table table-bordered table-radius"
                                >
                                    <thead>
                                        <tr align="center">
                                            <th style={{ borderRadius: '0px' }}>No</th>
                                            <th>Kode Mata Kuliah</th>
                                            <th>Nama Mata Kuliah</th>
                                            <th>Status</th>
                                            <th>SKS Teori</th>
                                            <th>SKS Praktek</th>
                                            <th>B/U</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            !isLoading ?
                                                data.length !== 0 ?
                                                    data.map((v, index) => {
                                                        return (
                                                            <tr height={10} key={index}>
                                                                <td align="center">{index + 1}</td>
                                                                <td align="center">
                                                                    <button type="button"
                                                                        title="detail nilai mk"
                                                                        className="btn btn-primary btn-sm btn-nilai" data-toggle="modal" data-target="#nilai">
                                                                        {v.kodemk}
                                                                    </button>
                                                                </td>
                                                                <td>{v.namamk}</td>
                                                                <td align="center"><span className={`badge badge-${statusTheme(v.statuskrs)}`} style={{ fontSize: '14px' }}>{v.statuskrs == "Disetujui" ? "Di Setujui" : v.statuskrs}</span></td>
                                                                <td align="center">{v.sksteori}</td>
                                                                <td align="center">{v.skspraktek}</td>
                                                                <td align="center">{v.bu}</td>
                                                            </tr>
                                                        )
                                                    })
                                                    : <> {tableAddOns('null')} </>
                                                : <> {tableAddOns('loading')} </>
                                        }
                                    </tbody>
                                    <tfoot>
                                        <tr className="customPadding customTable">
                                            <td colSpan={4}>Total SKS Semester Ini</td>
                                            <td align="center">{sksteori_semesterini}</td>
                                            <td align="center">{skspraktek_semesterini}</td>
                                            <td align="center">{sks_semesterini}</td>
                                        </tr>
                                        <tr className="customPadding customTable">
                                            <td colSpan={4}>Total SKS yang sudah diambil s.d. semester {semester}</td>
                                            <td align="center">{sksteori_semuasemester}</td>
                                            <td align="center">{skspraktek_semuasemester}</td>
                                            <td align="center">{sks_semuasemester}</td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                            <br />
                            <button className="btn btn-success" type="button" style={{ float: 'right' }}
                                onClick={this.print}
                            >
                                <i className="fa fa-print"></i>&nbsp;&nbsp;Cetak KRS .PDF
                            </button>
                        </div>
                    </div>
                </div>

                {/* print area  */}
                <div style={{ display: 'none' }}>
                    <div>
                        <table id="headerTabel">
                            <thead></thead>
                            <tbody className='times'>
                                <tr>
                                    <td>Nama</td>
                                    <td> : </td>
                                    <td>{Capitalize(nama)}</td>

                                    <td>Tahun Angkatan</td>
                                    <td> : </td>
                                    <td>{angkatan}</td>
                                </tr>
                                <tr>
                                    <td>NIM</td>
                                    <td> : </td>
                                    <td>{nim}</td>

                                    <td>Tahun Akademik</td>
                                    <td> : </td>
                                    <td>{ta}</td>
                                </tr>
                                <tr>
                                    <td>Program Studi</td>
                                    <td> : </td>
                                    <td>{jurusan}</td>

                                    <td>Semester</td>
                                    <td> : </td>
                                    <td>{selectedSemester}</td>
                                </tr>
                                <tr>
                                    <td>Konsentrasi</td>
                                    <td> : </td>
                                    <td>-</td>
                                </tr>
                            </tbody>
                        </table>

                        <table id="tabelKRS">
                            <thead>
                                <tr align="center">
                                    <th>No</th>
                                    <th>Kode Mata Kuliah</th>
                                    <th>Nama Mata Kuliah</th>
                                    <th>SKS Teori</th>
                                    <th>SKS Praktek</th>
                                    <th>B/U</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    data.length !== 0 ?
                                        data.map((v, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td align="center">{index + 1}</td>
                                                    <td align="center">{v.kodemk}</td>
                                                    <td>{v.namamk}</td>
                                                    <td align="center">{v.sksteori}</td>
                                                    <td align="center">{v.skspraktek}</td>
                                                    <td align="center">{v.bu}</td>
                                                </tr>
                                            )
                                        })
                                        : <> {tableAddOns('null')} </>
                                }
                                <tr>
                                    <td colSpan={3}>Total SKS Semester Ini</td>
                                    <td>{sksteori_semesterini}</td>
                                    <td>{skspraktek_semesterini}</td>
                                    <td align="center">{sks_semesterini}</td>
                                    <td align="center">{sks_semesterini}</td>
                                </tr>
                                <tr>
                                    <td colSpan={3}>Total SKS yang sudah diambil s.d. semester {semester}</td>
                                    <td>{sksteori_semuasemester}</td>
                                    <td>{skspraktek_semuasemester}</td>
                                    <td align="center">{sks_semuasemester}</td>
                                </tr>
                            </tbody>
                        </table>

                        <table id="ttd">
                            <tbody>
                                <tr>
                                    <td>&nbsp;</td>
                                </tr>
                                <tr>
                                    <td>Malang, {tanggal}</td>
                                </tr>
                                <tr>
                                    <td>Dosen Wali,</td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                </tr>
                                <tr>
                                    <td>
                                        {dosenwali}
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        {output2}
                                    </td>
                                </tr>
                                <tr>
                                    <td>NIDN.{nidn}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                {/* end of print area  */}
            </Fragment >
        );
    }
}

export default Krs;